import React, { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";

// Component to scroll to top on route change, unless there's a hash in the URL
// Moved from App.tsx to Routes.tsx as a layout route to ensure it's rendered within Router context (useLocation requires Router)
const ScrollToTop: React.FC = () => {
  // Get current location
  const location = useLocation();
  
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location]);

 // Render child routes using <Outlet> to display nested route components
  return <Outlet />;
};

export default ScrollToTop;